import React from 'react';
import github from '../assets/github-mark-white.svg'

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-[#4C4C6F] text-white py-6"> {/* bg-gray-800 */}
        <div className="container mx-auto flex justify-between items-center px-4">
            <p className="text-sm">&copy; {currentYear} Lukeuke. All rights reserved.</p>
            <div className="flex space-x-4">
                <a href="https://github.com/Lukeuke" className="text-gray-300 hover:text-gray-400" target='_blank' rel="noreferrer">
                    <img src={github} alt='Github' title='Github' className='w-7' />
                </a>
            </div>
        </div>
        </footer>
    );
}

export default Footer;
